import { dummyBalance, dummyUsers } from "../dummyData";
import { sortUsersByPreferredOrder } from "../userSorting";
import {
  handleError,
  handleRequestError,
  hostUrl,
  jsonHeaders,
  message,
  request,
  withDummyFallback,
} from "./core";

export const listUsers = () => {
  const config = {
    method: "get",
    maxBodyLength: Infinity,
    url: hostUrl("/users/list"),
    headers: jsonHeaders(),
  };
  return request(config)
    .then((response) => withDummyFallback(response.data, dummyUsers))
    .catch((error) =>
      handleRequestError(error, dummyUsers, { networkFallback: [] }),
    )
    .then(sortUsersByPreferredOrder);
};

export const autoLogin = () => {
  const config = {
    method: "get",
    maxBodyLength: Infinity,
    url: hostUrl("/users/autologin"),
    headers: jsonHeaders(),
  };
  return request(config)
    .then((response) => withDummyFallback(response.data, dummyBalance))
    .catch((error) => handleRequestError(error, dummyBalance));
};

export const resetUser = () => {
  const config = {
    method: "get",
    maxBodyLength: Infinity,
    url: hostUrl("/users/start/trade"),
    headers: jsonHeaders(),
  };
  return request(config)
    .then((response) => response.data)
    .catch((error) => {
      handleError(error);
      message.error(error?.response?.data?.message || "Server is Down");
    });
};

export const resetActionServer = () => {
  const config = {
    method: "get",
    maxBodyLength: Infinity,
    url: hostUrl("/users/restart/action"),
    headers: jsonHeaders(),
  };
  return request(config)
    .then((response) => response.data)
    .catch((error) => {
      handleError(error);
      message.error(error?.response?.data?.message || "Server is Down");
    });
};

export const createUsers = (payload) => {
  const config = {
    method: "post",
    maxBodyLength: Infinity,
    url: hostUrl("/users/create"),
    headers: jsonHeaders(),
    data: JSON.stringify(payload),
  };
  return request(config)
    .then(() => {
      message.success("User saved successfully");
    })
    .catch((error) => {
      message.error(error?.response?.data?.message || "Server is Down");
      handleError(error);
    });
};

export const deleteUser = (id) => {
  if (!id) return;
  const config = {
    method: "delete",
    maxBodyLength: Infinity,
    url: hostUrl("/users/delete"),
    headers: jsonHeaders(),
    data: JSON.stringify({ id }),
  };
  return request(config)
    .then((response) => response.data)
    .catch((error) => {
      handleError(error);
      message.error(error?.response?.data?.message || "Server is Down");
    });
};
